import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';

const BudgetPeriod: FC<GridCellProps> = (props) => {
  const { dataItem, field = '' } = props;

  const value = useMemo(() => dataItem?.[field], [dataItem, field]);

  return (
    <GridCellBase {...props}>
      <span>{value}</span>
    </GridCellBase>
  );
};

export default BudgetPeriod;
